/* eslint-disable consistent-this */
/* eslint-disable object-shorthand */
import {NextRouter} from "next/router";

const functions = {
	bccard: function (size) {
		const iframe: HTMLFormElement = document.querySelector("#iframePartner");
		iframe.contentWindow.location.replace(
			`https://isrnd.bccard.com:34443/app/paybooc/view/common/cross_resize.jsp?height=${size + 50}`,
		);
	},
	gmarket: function (size) {
		const router = this;
		const form: HTMLFormElement = document.querySelector("#iframePartnerForm");
		const fromHeight: HTMLInputElement = form.querySelector("[name=h]");
		form.setAttribute(
			"action",
			router.query?.SITE_ID === "G"
				? "https://tour-dev.gmarket.co.kr/TourJaehu/IframeResize"
				: "https://tour-dev.auction.co.kr/TourJaehu/IframeResize",
		);
		fromHeight.value = `${size + 150}`;
		form.submit();
	},
};

function develop(router: NextRouter) {
	const partnerName = (router.query?.$partnerName as string) || "gmarket";
	return functions[partnerName].bind(router);
}

export default develop;
